import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlogsComponent } from './blogs.component';
import { BlogsDetailComponent } from './blogs-detail/blogs-detail.component';


const routes: Routes = [
  { path: '', component: BlogsComponent },
  { path: 'blogs/blogs-detail', component: BlogsDetailComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogsRoutingModule { }
